function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M17 8a.48.48 0 00.35-.15c.1-.1.15-.217.15-.35v-3a.48.48 0 00-.15-.35.48.48 0 00-.7 0 .48.48 0 00-.15.35v3c0 .133.05.25.15.35.1.1.217.15.35.15zm0 2a.48.48 0 00.35-.15.48.48 0 000-.7.48.48 0 00-.7 0 .48.48 0 000 .7c.1.1.217.15.35.15zm-1.5 7c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0015.5 14c-.417 0-.77.146-1.063.438A1.446 1.446 0 0014 15.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm-9 0c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 006.5 14c-.417 0-.77.146-1.063.438A1.447 1.447 0 005 15.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zM17 12c-1.383 0-2.563-.488-3.537-1.463C12.488 9.563 12 8.383 12 7c0-1.367.483-2.542 1.45-3.525C14.417 2.492 15.6 2 17 2c1.383 0 2.563.487 3.538 1.462C21.512 4.438 22 5.617 22 7s-.488 2.563-1.462 3.537C19.562 11.512 18.383 12 17 12zM3.5 22c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 012 20.5v-7.15c0-.117.008-.233.025-.35.017-.117.042-.225.075-.325L4.1 7c.1-.3.28-.542.538-.725C4.896 6.092 5.183 6 5.5 6h3.475c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 018.975 8H5.85L4.8 11h5.975c.15 0 .296.033.438.1a.962.962 0 01.362.3 7.079 7.079 0 002.413 1.912A6.794 6.794 0 0017 14a6.712 6.712 0 001.825-.25.893.893 0 01.8.137c.25.175.375.405.375.688V20.5c0 .417-.146.77-.438 1.063A1.446 1.446 0 0118.5 22c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0117 20.5V20H5v.5c0 .417-.146.77-.438 1.063A1.446 1.446 0 013.5 22z"
  }));
};
const SvgCarDamage = styled(BaseComponent).withConfig({
  displayName: "CarDamage__SvgCarDamage",
  componentId: "sc-9rgles-0"
})(["outline:none;"]);
SvgCarDamage.isIcon = true;
export default SvgCarDamage;